import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";
import { WorldInterface } from "../../store/mods_factory/worldsSlice";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: modsfactoryUrls.worldPath(value.id),
    thumbnail_url: modsfactoryUrls.remoteUrl(value.thumbnail_url),
    mcworld_url: modsfactoryUrls.remoteUrl(value.mcworld_url)
  };
}

const worldsEntity = new schema.Entity(
  'worlds',
  {},
  {
    processStrategy
  }
);

const worldEntity = new schema.Entity(
  'world',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { world: WorldInterface }>(response.data.world, worldEntity);
  return normalized.entities;
}

export const fetchWorlds = createAsyncThunk(
  `${PREFIX}_worlds/fetchWorlds`,
  async (params: object = {}) => {
    const response    = await modsFactoryApi.get(`/onesky/worlds`, { params })
    const normalized  = normalize<any, { worlds: { [key: string]: WorldInterface } }>(response.data.worlds, [worldsEntity]);

    return {
      worlds: normalized.entities?.worlds || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchWorld = createAsyncThunk(
  `${PREFIX}_worlds/fetchWorld`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/worlds/${id}`);
    return normalizeInstance(response);
  }
);

export const createWorld = createAsyncThunk(
  `${PREFIX}_worlds/createWorld`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.post(`/onesky/worlds`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateWorld = createAsyncThunk(
  `${PREFIX}_worlds/updateWorld`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/worlds/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyWorld = createAsyncThunk(
  `${PREFIX}_worlds/destroyWorld`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/worlds/${id}`);
    return response.data;
  }
);
